/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineIdDto } from './machineIdDto';
import { ImplementIdDto } from './implementIdDto';

export interface CombinationDto {
  implementPrimary?: ImplementIdDto;
  implementSecondary?: ImplementIdDto;
  machine?: MachineIdDto;
}
